import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ERRO_CAMPOS_OBRIGATORIOS, ERRO_FORMATO_EMAIL_INVALIDO, ERRO_AUTENTICACAO_CAPTCHA } from 'src/app/tools/Mensagens';
import { PAGINA_LOGIN } from '../../../tools/URL';
import { AuthService } from '../../../service/autenticacao/auth.service';

const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'esqueci-senha-email',
  templateUrl: './esqueci-senha-email.component.html',
  styleUrls: ['./esqueci-senha-email.component.css']
})
export class EsqueciSenhaEmailComponent implements OnInit {

  myRecaptcha = new FormControl(false);
  email: string | null;
  cpfCnpj: string | null;
  cpfCnpjMask = '000.000.000-00';
  urlLogin = PAGINA_LOGIN;

  constructor(private authService: AuthService) {
    this.email = null;
    this.cpfCnpj = null;
  }

  ngOnInit() {}

  onCpfCnpjKeydown(event: KeyboardEvent) {
    if (event.ctrlKey || event.altKey || event.metaKey) {
      return;
    }

    const key = event.key;

    if (key.length !== 1) {
      return;
    }

    if (/[a-zA-Z]/.test(key)) {
      this.cpfCnpjMask = 'AA.AAA.AAA/AAAA-AA';
    }
  }

  onCpfCnpjPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData ? event.clipboardData.getData('text') : '';
    const raw = (pastedText || '').replace(/[^a-zA-Z0-9]/g, '');

    this.cpfCnpjMask = /[a-zA-Z]/.test(raw) || raw.length > 11
      ? 'AA.AAA.AAA/AAAA-AA'
      : '000.000.000-00';
  }

  onCpfCnpjChange(value: string) {
    const raw = (value || '').replace(/[^a-zA-Z0-9]/g, '');

    if (!raw) {
      this.cpfCnpjMask = '000.000.000-00';
      return;
    }

    this.cpfCnpjMask = /[a-zA-Z]/.test(raw) || raw.length > 11
      ? 'AA.AAA.AAA/AAAA-AA'
      : '000.000.000-00';
  }

  camposValidos(email: string | null, cpfCnpj: string | null, myRecaptcha: FormControl) {

    if (!myRecaptcha.value) {

      alert(ERRO_AUTENTICACAO_CAPTCHA);

      return false;

    }

    if ((email === null || email === '') && (cpfCnpj === null || cpfCnpj === '')) {

      alert(ERRO_CAMPOS_OBRIGATORIOS);

      return false;

    }

    if (email !== null && email !== '' && !EMAIL_REGEX.test(email)) {

      alert(ERRO_FORMATO_EMAIL_INVALIDO);

      return false;

    }

    return true;

  }

  enviar() {

    if (this.camposValidos(this.email, this.cpfCnpj, this.myRecaptcha)) {

      this.authService.esqueciMinhaSenhaEmail(this.email, this.cpfCnpj);

    }

  }

}
